import React from 'react';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import OrphanedAssignmentService from '../../../../Services/OrphanedAssignmentService';
import OrphanAssignmentItem from '../../../../Domain/OrphanAssignmentItem';
import OrphanedAssignmentSearchParams from './OrphanedAssignmentSearchParams';

export default class AssignmentListOrphanClientAdmin extends React.Component {
  static defaultProps = {
    surveyId: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      searchItem: new OrphanedAssignmentSearchParams(),
    };

    this.state.searchItem.SurveyNameOrId = this.props.surveyId;

    this.startSearch = this.startSearch.bind(this);
  }

  startSearch(searchItem) {
    this.setState({
      searchItem: { ...searchItem, SurveyNameOrId: this.props.surveyId },
    });
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={OrphanAssignmentItem}
          serviceFunction={OrphanedAssignmentService.GetAssignmentListOrphanClient}
          convertDBItemsFunction={OrphanedAssignmentService.ConvertOrphanAssignmentDBItems}
          searchItem={this.state.searchItem}
          searchParamsType={OrphanedAssignmentSearchParams}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          orderBy='AsSassieSurveyId'
          errorCode='ALOCA26'
        />
      </div>
    );
  }
}
